import React from 'react';
import './App.css';

export const Loader = () => (
  <div className="loader">
  </div>
);
